import moment from "moment";

const Input = (props) => {
  const data = props.data;

  const maxDate = (data) => {
    if (data.name == "from_date") {
      return data.type == "date" ? moment().format("YYYY-MM-DD") : "";
    }
    if (data.name == "to_date") {
      return data.type == "date"
        ? moment().format("YYYY-MM-DD")
        : "";
    }
  };

  const minDate = (data) => {
    if (data.name == "to_date") {
      return data.type == "date"
        ? moment(props.state.from_date).format("YYYY-MM-DD")
        : "";
    }
  };

  return (
    <>
      <div className="col-md-3">
        <label htmlFor={data.name}>
          {data.label}{" "}
          {data?.required && <span className="text-danger">*</span>}
        </label>
        <input
          className="form-control"
          type={data.type}
          name={data.name}
          id={data.name}
          value={props.state[data.name]}
          max={maxDate(data)} //today onwards
          min={minDate(data)} //before today
          onChange={(e) => props.handleInput(e)}
        />
      </div>
    </>
  );
};

export default Input;
